import React, { useEffect, useState } from 'react'
import {
    EmailShareButton,
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailIcon,
    FacebookIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";
import usePopup from '../hooks/usePopup';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Popup from '../Popup/Popup';
import Translation from './Translation';
import getTranslation from '../functions/getTranslation';



const CopyUrlToClipboard = ({url, translation}) => {
    const [isCopied, setCopied] = useState(false)

    useEffect(() => {
        const timeOutId = setTimeout(() => setCopied(false), 2500)
    
        return () => {
            if(timeOutId) {
                clearTimeout(timeOutId)
            }
        }
    })

    return (
        url ? (
            <form className="copy-clipboard-url">
                <div className="copy-wrapper">
                    <input 
                        className="copy-url popup-button theme-radius-posters-full text-small-medium"
                        type="url" 
                        readOnly={true} 
                        value={url}
                    />

                    <CopyToClipboard 
                        text={url} 
                        onCopy={() => setCopied(true)}
                    >
                        <input 
                            className="copy-button popup-button theme-radius-posters-full button text-medium cursor-pointer"
                            type="button" 
                            value={getTranslation("popupSharingCopy", translation)}
                        />
                    </CopyToClipboard>
                </div>

                {isCopied && <div className="copy-success text-small-medium ">
                    <Translation id="popupSharingCopyToClipboard" trans={translation}>Link in Zwischenablage kopiert</Translation>
                </div>}
            </form>
        ) : ''
    )
}

const ShareButtons = ({url, title, description, translation}) => {
    const [displayPopup, openPopup, closePopup]  = usePopup()
    const buttonSize = 50

    return (
        <div className="share-buttons">
            <div className="share-buttons-toggle cursor-pointer" onClick={openPopup}>
                <svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.07 50">
                    <g id="Gruppe_30">
                        <path id="Pfad_49" className="cls-1" d="M36.24,14.75c.14,0,.28,.03,.42,.03h0c4.08,.01,7.4-3.29,7.41-7.37C44.08,3.33,40.78,.01,36.7,0c-3.91-.01-7.16,3.03-7.39,6.94-.05,.94,.07,1.89,.37,2.79L12.14,20.19c-3.08-2.65-7.72-2.29-10.37,.79-2.65,3.08-2.29,7.72,.79,10.37,1.33,1.14,3.03,1.77,4.79,1.77,1.66,0,3.27-.56,4.56-1.61l17.1,9.3c-.45,1.75-.22,3.59,.62,5.18,1.26,2.45,3.78,4,6.54,4h0c1.18,0,2.34-.31,3.38-.87,3.6-1.89,5.01-6.33,3.16-9.95-1.26-2.45-3.79-3.98-6.54-3.97-1.18,0-2.34,.29-3.38,.85-.84,.44-1.58,1.03-2.2,1.75L14.06,28.81c.44-.96,.67-2.01,.68-3.07,0-.98-.19-1.94-.56-2.85L31.5,12.61c1.25,1.29,2.94,2.05,4.74,2.14Zm-3.55-7.58c.11-2.11,1.86-3.76,3.97-3.75h.22c2.19,.13,3.87,2.01,3.75,4.2-.13,2.19-2.01,3.87-4.2,3.75-2.19-.13-3.87-2-3.75-4.2h0ZM3.38,25.77c0-2.19,1.78-3.97,3.97-3.97s3.97,1.78,3.97,3.97-1.78,3.97-3.97,3.97h0c-2.19,0-3.97-1.77-3.97-3.96,0,0,0,0,0-.01h0Zm30.97,13.3c.56-.3,1.19-.46,1.83-.45,1.49,0,2.86,.82,3.55,2.14,1.01,1.94,.26,4.33-1.68,5.35,0,0,0,0-.01,0-.56,.3-1.19,.46-1.83,.45h0c-1.49,0-2.86-.82-3.55-2.14-.49-.94-.58-2.04-.25-3.04,.3-1.01,1-1.85,1.95-2.31h0Z"/>
                    </g>
                </svg>
                <p className='screen-reader-text'><Translation id="popupOpenSharing" trans={translation}>Open social media charing popup</Translation></p>
            </div>

            <Popup addClassToBackdrop="share-buttons-popup" addClassToPopup="popup-content-share-buttons popup-content-small" displayPopup={displayPopup} onClosePopup={closePopup} translation={translation}>
                <div className="popup-content-center  share-buttons-wrapper">
                    <FacebookShareButton 
                        url={url}
                    >
                        <FacebookIcon size={buttonSize}/>
                    </FacebookShareButton>
                    <TwitterShareButton 
                        url={url}
                        title={title}
                    >
                        <TwitterIcon  size={buttonSize} />
                    </TwitterShareButton>
                    <WhatsappShareButton 
                        url={url}
                        title={title}
                        separator={"\n"}
                    >
                        <WhatsappIcon size={buttonSize} />
                    </WhatsappShareButton>
                    <TelegramShareButton 
                        url={url}
                        title={title}
                    >
                        <TelegramIcon size={buttonSize} />
                    </TelegramShareButton>

                    <EmailShareButton 
                        url={url}
                        subject={title}
                        body={description ? title + "\n\n" + description : title}
                        separator={"\n\n"}
                    >
                        <EmailIcon size={buttonSize} />
                    </EmailShareButton>
                    <CopyUrlToClipboard 
                        url={url} 
                        translation={translation}
                    />
                </div>
            </Popup>
        </div>
    )
}

export default ShareButtons